<template>
	<div class="repository_container">
		<div class="container wide">
			<div class="d-flex gap16 f-d-c">
				<div v-if="repo_list.length > 0" class="box_style_tabs ml-auto mb0i w100p flex-1-1-a">
					<div class="pagin_el" :class="{pagin_el_active: active_type == 'all'}">
						<a href="#" @click.prevent="changeViewType('all')"><span>All</span></a>
					</div>
					<div v-for="pagin in repo_list" :key="pagin.id" class="pagin_el" :class="{pagin_el_active: active_type == pagin.id}">
						<a v-if="pagin.buckets.length" href="#" @click.prevent="changeViewType(pagin.id)"><span>{{ pagin.name }}</span></a>
					</div>
					<div v-if="sample_codes.length > 0" class="pagin_el" :class="{pagin_el_active: active_type == 'sample_codes'}">
						<a href="#" @click.prevent="changeViewType('sample_codes')"><span>Sample Codes</span></a>
					</div>
				</div>
				<div class="box_style p24 repoSearch">
					<div class="table-search">
						<div class="line-icon-wrap">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21 21L15.8033 15.8033M15.8033 15.8033C17.1605 14.4461 18 12.5711 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C12.5711 18 14.4461 17.1605 15.8033 15.8033Z" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
							<input type="text" name="search" v-model="filterSearchString" placeholder="Search by platform, framework or sample code"></input>
						</div>
					</div>

					<div v-if="platformList.length > 0" class="repo-filter-bar mla">
						<span class="title">Filter by:</span>
						<div class="buttons">
							<button
								v-for="platform in platformList"
								:key="platform.key"
								class="platform-btn"
								:class="{[platform.key]: true, active: active_platform === platform.key }"
								@click.prevent="changePlatformFilter(platform.key)"
								v-tooltip="platform.label"
							>
								<svg><use :xlink:href="spriteHref(platform.icon.slice(1))"></use></svg>
							</button>
						</div>
					</div>
				</div>

				<template v-if="filteredTypes.length && !isLoading">
					<div v-for="group in groupedByCategory" :key="group.id" class="category-group">
						<div class="category-separator">
							<span class="category-separator-label">{{ group.name }}</span>
							<span class="category-separator-line"></span>
						</div>
						<TransitionGroup name="stagger" tag="div" class="bucketList" appear>
							<template v-for="(entry, index) in group.items" :key="entry.type === 'bucket' ? entry.bucket.id : 'sc_' + entry.item.id">
								<!-- BUCKET CARD -->
								<div v-if="entry.type === 'bucket'" class="box_style bucket p24">
									<div class="flex gap16 align-center" v-if="entry.bucket.releases.length > 0">
										<div class="bucketIcon">
											<svg><use :xlink:href="spriteHref(getPlatform(entry.bucket.name) + '_logo')"></use></svg>
										</div>
										<div class="info">
											<h3>{{ entry.bucket.name }} {{ latestVersion(entry.bucket.releases) }}</h3>
											<p>Release date: {{ formatDate(entry.bucket.releases[0]['release_date']) }}</p>
										</div>
										<div class="olderRelasesButtons">
											<button v-if="entry.bucket.description" class="older_files" v-tooltip="'Description'" @click.prevent="openDescriptionModal(entry.bucket)">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><use :xlink:href="spriteHref('info')"></use></svg>
											</button>
											<button v-if="entry.bucket.releases.length > 0" @click.prevent="showOlderVersions(entry.bucket)" class="older_files" v-tooltip="'Older Versions'">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none"><use :xlink:href="spriteHref('repository')"></use></svg>
											</button>
										</div>
									</div>

									<div class="flex gap16 flex-column flex-wrap">
										<div v-if="entry.bucket.name" class="flex flex-column gap8 flex-grow-1 flex-wrap flex-1-1-0">
											<p class="title">Latest Version</p>
											<button class="bucket-button" @click.prevent="eulaAgree(homeUrl+'repository/download/latest/'+entry.bucket.slug_form)">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
													<use :xlink:href="spriteHref('download')"></use>
												</svg>
												{{ entry.bucket.slug_form }}_{{ latestVersion(entry.bucket.releases) }}.zip
											</button>
											<button class="bucket-button" @click.prevent="copyDownloadLink(homeUrl+'repository/download/latest/'+entry.bucket.slug_form)">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="none">
													<path fill-rule="evenodd" clip-rule="evenodd" d="M14 3C13.3267 3 12.7552 3.44413 12.5662 4.05717C12.5234 4.19622 12.5 4.34469 12.5 4.5H17C17 4.34469 16.9766 4.19622 16.9338 4.05717C16.7448 3.44413 16.1733 3 15.5 3H14ZM11.337 3.11765C11.8367 2.15693 12.8409 1.5 14 1.5H15.5C16.6591 1.5 17.6633 2.15693 18.163 3.11765C18.3877 3.13319 18.6121 3.15026 18.8359 3.16884C20.3752 3.2966 21.5 4.60282 21.5 6.10822V16.5C21.5 18.1569 20.1569 19.5 18.5 19.5H17V20.625C17 21.6605 16.1605 22.5 15.125 22.5H5.375C4.33947 22.5 3.5 21.6605 3.5 20.625V9.375C3.5 8.33947 4.33947 7.5 5.375 7.5H8V6.10822C8 4.60283 9.12475 3.2966 10.664 3.16884C10.8879 3.15026 11.1123 3.13319 11.337 3.11765ZM11.007 4.64604C10.934 4.65177 10.861 4.65765 10.7881 4.6637C10.0652 4.7237 9.5 5.34365 9.5 6.10822V7.5H15.125C16.1605 7.5 17 8.33947 17 9.375V18H18.5C19.3284 18 20 17.3284 20 16.5V6.10822C20 5.34365 19.4348 4.7237 18.7119 4.6637C18.639 4.65765 18.566 4.65177 18.493 4.64604C18.4196 5.40594 17.7792 6 17 6H12.5C11.7208 6 11.0804 5.40594 11.007 4.64604ZM15.5 9.375C15.5 9.16789 15.3321 9 15.125 9H5.375C5.16789 9 5 9.16789 5 9.375V20.625C5 20.8321 5.16789 21 5.375 21H15.125C15.3321 21 15.5 20.8321 15.5 20.625V9.375ZM6.5 12C6.5 11.5858 6.83579 11.25 7.25 11.25H7.2575C7.67171 11.25 8.0075 11.5858 8.0075 12V12.0075C8.0075 12.4217 7.67171 12.7575 7.2575 12.7575H7.25C6.83579 12.7575 6.5 12.4217 6.5 12.0075V12ZM8.75 12C8.75 11.5858 9.08579 11.25 9.5 11.25H13.25C13.6642 11.25 14 11.5858 14 12C14 12.4142 13.6642 12.75 13.25 12.75H9.5C9.08579 12.75 8.75 12.4142 8.75 12ZM6.5 15C6.5 14.5858 6.83579 14.25 7.25 14.25H7.2575C7.67171 14.25 8.0075 14.5858 8.0075 15V15.0075C8.0075 15.4217 7.67171 15.7575 7.2575 15.7575H7.25C6.83579 15.7575 6.5 15.4217 6.5 15.0075V15ZM8.75 15C8.75 14.5858 9.08579 14.25 9.5 14.25H13.25C13.6642 14.25 14 14.5858 14 15C14 15.4142 13.6642 15.75 13.25 15.75H9.5C9.08579 15.75 8.75 15.4142 8.75 15ZM6.5 18C6.5 17.5858 6.83579 17.25 7.25 17.25H7.2575C7.67171 17.25 8.0075 17.5858 8.0075 18V18.0075C8.0075 18.4217 7.67171 18.7575 7.2575 18.7575H7.25C6.83579 18.7575 6.5 18.4217 6.5 18.0075V18ZM8.75 18C8.75 17.5858 9.08579 17.25 9.5 17.25H13.25C13.6642 17.25 14 17.5858 14 18C14 18.4142 13.6642 18.75 13.25 18.75H9.5C9.08579 18.75 8.75 18.4142 8.75 18Z" fill="#E52E4C"/>
												</svg>
												Get link
											</button>
										</div>
										<div v-if="entry.bucket.external_links && entry.bucket.external_links.length" class="flex flex-column gap8">
											<p class="title">Resources</p>
											<div class="flex flex-wrap gap8">
												<a v-for="external_link in entry.bucket.external_links" :key="external_link.url" v-tooltip="external_link.text" class="bucket-button small" target="_blank" :href="external_link.url">
													<svg v-if="containsString(external_link.text, 'github')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
														<use :xlink:href="spriteHref('github')"></use>
													</svg>
													<svg v-else-if="containsString(external_link.text, 'npmjs')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
														<use :xlink:href="spriteHref('npmLogo')"></use>
													</svg>
													<svg v-else-if="containsString(external_link.text, 'documentation')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
														<use :xlink:href="spriteHref('documentation')"></use>
													</svg>
													<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
														<use :xlink:href="spriteHref('anchorBlank')"></use>
													</svg>
												</a>
											</div>
										</div>
									</div>
								</div>

								<!-- SAMPLE CODE CARD (in grouped view) -->
								<div v-else class="box_style bucket p24">
									<div class="flex gap16 align-center">
										<div class="bucketIcon">
											<img v-if="typeof entry.item.image_url != 'undefined' && entry.item.image_url" :src="entry.item.image_url" />
											<svg v-else><use :xlink:href="spriteHref('wasm_logo')"></use></svg>
										</div>
										<div class="info">
											<h3>{{ entry.item.name }}</h3>
											<p>Last Updated: {{ formatDate(entry.item['last_updated']) }}</p>
										</div>
										<div class="olderRelasesButtons">
											<button v-if="entry.item.description" class="older_files" v-tooltip="'Description'" @click.prevent="openSampleCodeDescriptionModal(entry.item)">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><use :xlink:href="spriteHref('info')"></use></svg>
											</button>
										</div>
									</div>

									<div class="flex gap16 flex-column flex-wrap">
										<div v-if="entry.item.name && entry.item.slug_form && entry.item.file_id" class="flex flex-column gap8 flex-grow-1 flex-wrap flex-1-1-0">
											<p class="title">Get latest sample</p>
											<button class="bucket-button" @click.prevent="copyDownloadLink(homeUrl+'repository/download/sample_code/'+entry.item.slug_form)">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="none">
													<path fill-rule="evenodd" clip-rule="evenodd" d="M14 3C13.3267 3 12.7552 3.44413 12.5662 4.05717C12.5234 4.19622 12.5 4.34469 12.5 4.5H17C17 4.34469 16.9766 4.19622 16.9338 4.05717C16.7448 3.44413 16.1733 3 15.5 3H14ZM11.337 3.11765C11.8367 2.15693 12.8409 1.5 14 1.5H15.5C16.6591 1.5 17.6633 2.15693 18.163 3.11765C18.3877 3.13319 18.6121 3.15026 18.8359 3.16884C20.3752 3.2966 21.5 4.60282 21.5 6.10822V16.5C21.5 18.1569 20.1569 19.5 18.5 19.5H17V20.625C17 21.6605 16.1605 22.5 15.125 22.5H5.375C4.33947 22.5 3.5 21.6605 3.5 20.625V9.375C3.5 8.33947 4.33947 7.5 5.375 7.5H8V6.10822C8 4.60283 9.12475 3.2966 10.664 3.16884C10.8879 3.15026 11.1123 3.13319 11.337 3.11765ZM11.007 4.64604C10.934 4.65177 10.861 4.65765 10.7881 4.6637C10.0652 4.7237 9.5 5.34365 9.5 6.10822V7.5H15.125C16.1605 7.5 17 8.33947 17 9.375V18H18.5C19.3284 18 20 17.3284 20 16.5V6.10822C20 5.34365 19.4348 4.7237 18.7119 4.6637C18.639 4.65765 18.566 4.65177 18.493 4.64604C18.4196 5.40594 17.7792 6 17 6H12.5C11.7208 6 11.0804 5.40594 11.007 4.64604ZM15.5 9.375C15.5 9.16789 15.3321 9 15.125 9H5.375C5.16789 9 5 9.16789 5 9.375V20.625C5 20.8321 5.16789 21 5.375 21H15.125C15.3321 21 15.5 20.8321 15.5 20.625V9.375ZM6.5 12C6.5 11.5858 6.83579 11.25 7.25 11.25H7.2575C7.67171 11.25 8.0075 11.5858 8.0075 12V12.0075C8.0075 12.4217 7.67171 12.7575 7.2575 12.7575H7.25C6.83579 12.7575 6.5 12.4217 6.5 12.0075V12ZM8.75 12C8.75 11.5858 9.08579 11.25 9.5 11.25H13.25C13.6642 11.25 14 11.5858 14 12C14 12.4142 13.6642 12.75 13.25 12.75H9.5C9.08579 12.75 8.75 12.4142 8.75 12ZM6.5 15C6.5 14.5858 6.83579 14.25 7.25 14.25H7.2575C7.67171 14.25 8.0075 14.5858 8.0075 15V15.0075C8.0075 15.4217 7.67171 15.7575 7.2575 15.7575H7.25C6.83579 15.7575 6.5 15.4217 6.5 15.0075V15ZM8.75 15C8.75 14.5858 9.08579 14.25 9.5 14.25H13.25C13.6642 14.25 14 14.5858 14 15C14 15.4142 13.6642 15.75 13.25 15.75H9.5C9.08579 15.75 8.75 15.4142 8.75 15ZM6.5 18C6.5 17.5858 6.83579 17.25 7.25 17.25H7.2575C7.67171 17.25 8.0075 17.5858 8.0075 18V18.0075C8.0075 18.4217 7.67171 18.7575 7.2575 18.7575H7.25C6.83579 18.7575 6.5 18.4217 6.5 18.0075V18ZM8.75 18C8.75 17.5858 9.08579 17.25 9.5 17.25H13.25C13.6642 17.25 14 17.5858 14 18C14 18.4142 13.6642 18.75 13.25 18.75H9.5C9.08579 18.75 8.75 18.4142 8.75 18Z" fill="#E52E4C"/>
												</svg>
												Get link
											</button>
											<a class="bucket-button" @click.prevent="eulaAgree(homeUrl+'repository/download/sample_code/'+entry.item.slug_form)" href="#">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
													<use :xlink:href="spriteHref('download')"></use>
												</svg>
												{{ entry.item.slug_form }}{{ entry.item.file_data?.extension || '' }}
											</a>
										</div>
										<div v-if="entry.item.external_links && entry.item.external_links.length" class="flex flex-column gap8">
											<p class="title">Resources</p>
											<div class="flex flex-wrap gap8">
												<a v-for="external_link in entry.item.external_links" v-tooltip="external_link.text" :key="external_link.url" class="bucket-button small" target="_blank" :href="external_link.url">
													<svg v-if="containsString(external_link.text, 'github')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
														<use :xlink:href="spriteHref('github')"></use>
													</svg>
													<svg v-else-if="containsString(external_link.text, 'npmjs')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
														<use :xlink:href="spriteHref('npmLogo')"></use>
													</svg>
													<svg v-else-if="containsString(external_link.text, 'documentation')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
														<use :xlink:href="spriteHref('documentation')"></use>
													</svg>
													<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
														<use :xlink:href="spriteHref('anchorBlank')"></use>
													</svg>
												</a>
											</div>
										</div>
									</div>
								</div>
							</template>
						</TransitionGroup>
					</div>
				</template>
				<div v-else-if="isLoading" class="box_style p24">
					<div class="dot_loading line"></div>
				</div>
				<div v-else class="box_style bucket p24">
					<div class="flex gap16 align-center"><div class="info"><h3>...no results</h3></div></div>
				</div>

				<transition name="modal">
					<div class="vue-modal-mask" v-if="showBucket">
						<div class="vue-modal-overlay" @click.prevent="showBucket = null"></div>
						<div class="vue-modal-container gray w">
							<div class="vue-modal-body background-body">
								<div v-if="showBucket.releases.length > 0">
									<div class="p24-0 flex gap8 flex-column">
										<div v-for="(release,f_key) in showBucket.releases" :key="release.id" class="box_style mb0i bucket p24">
											<div class="flex gap24 flex-column">
												<div class="flex gap16 align-center flex-wrap">
													<div class="info">
														<h3>{{ release.name }} {{ f_key === 0?'(Latest Version)':'' }}</h3>
														<p>Release date: {{ formatDate(release.release_date) }}</p>
													</div>
													<div class="olderRelasesButtons">
														<a class="older_files v1" @click.prevent="eulaAgree(homeUrl+'repository/download/release/'+showBucket.slug_form+'/'+release.name)" href="#" :title="'Download'">
															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#E52E4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																<path d="M7 10L12 15L17 10" stroke="#E52E4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																<path d="M12 15V3" stroke="#E52E4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</a>
														<a class="older_files" @click.prevent="toggleReleaseNote(f_key)" href="#" :title="'Show Changelog'">
															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" fill="#E52E4C" stroke="#E52E4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																<path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="#E52E4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
																<path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="#E52E4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</a>
													</div>
												</div>
												<div v-if="release.showNote" class="changelog">
													<div class="changelogContent" v-html="release.release_note"></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="vue-modal-actions background-body">
								<button @click.prevent="showBucket = null" class="app-button right">Close</button>
							</div>
						</div>
					</div>
				</transition>

				<!-- Description Modal -->
				<transition name="modal">
					<div v-if="descriptionModal.show" class="vue-modal-mask">
						<div class="vue-modal-overlay" @click.prevent="closeDescriptionModal"></div>
						<div class="vue-modal-container w500">
							<div class="vue-modal-header">
								<h3>{{ descriptionModal.bucketName }}</h3>
								<a href="javascript:;" class="closeme" @click.prevent="closeDescriptionModal">
									<svg viewBox="0 0 25 25"><use :xlink:href="spriteHref('close')"></use></svg>
								</a>
							</div>
							<div class="vue-modal-body">
								<div class="bucket-description-content" v-html="descriptionModal.description"></div>
							</div>
							<div class="vue-modal-actions justify-content-right">
								<button @click.prevent="closeDescriptionModal" class="app-button right">Close</button>
							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
import { HOME_URL } from '../constants/envrionment';

const PLATFORM_LIST = [
	{ key: 'android',      label: 'Android',       icon: '#android_logo' },
	{ key: 'ios',          label: 'iOS',            icon: '#ios_logo' },
	{ key: 'windows',      label: 'Windows',        icon: '#windows_logo' },
	{ key: 'linux',        label: 'Linux',          icon: '#linux_logo' },
	{ key: 'wasm',         label: 'WebAssembly',    icon: '#wasm_logo' },
	{ key: 'react',        label: 'React Native',   icon: '#react_logo' },
	{ key: 'flutter',      label: 'Flutter',        icon: '#flutter_logo' },
	{ key: 'capacitor',    label: 'Capacitor',      icon: '#capacitor_logo' },
	{ key: 'maui',         label: '.NET MAUI',      icon: '#net_maui_logo' },
	{ key: 'cordova',      label: 'Cordova',        icon: '#cordova_logo' },
	{ key: 'nativescript', label: 'NativeScript',   icon: '#nativescript_logo' },
	{ key: 'xamarin',      label: 'Xamarin',        icon: '#xamarin_logo' },
	{ key: 'python',       label: 'Python',         icon: '#python_logo' },
];

export default {
	name: 'Repository',
	props: {
		isClient: { type: Number, default: 0 },
		accountActivated: { type: Number, default: 0 },
	},
	data() {
		return {
			homeUrl: HOME_URL,
			showBucket: null,
			active_type: 'all',
			active_platform: '',
			sample_codes: [],
			filterSearchString: '',
			repo_list: [],
			isLoading: true,
			subscribeLoading: false,
			platformList: PLATFORM_LIST,
			descriptionModal: {
				show: false,
				bucketName: '',
				description: ''
			},
			latest_release: {},
			show_preview_email: false,
		}
	},
	watch: {
		filterSearchString: function(val){
			this.active_type = ''
			this.active_platform = ''
		}
	},
	computed: {
		filteredTypes() {
			let res = [...this.repo_list, ...this.sample_codes];

			if (this.active_type && this.active_type != '') {
				if (this.active_type == 'all') {
					res = res.slice();
				}
				else if (this.active_type == 'sample_codes') {
					res = this.sample_codes.slice();
				} else {
					res = res.filter(type => type.id == this.active_type);
				}
			}

			if (this.filterSearchString) {
				const lowerCaseSearchTerm = this.filterSearchString.toLowerCase();
				res = res.map(item => {
					if (typeof item.buckets != 'undefined') {
						const filteredList = item.buckets.filter(subItem =>
							subItem.name.toLowerCase().includes(lowerCaseSearchTerm)
						);
						return filteredList.length > 0 ? { ...item, buckets: filteredList } : null;
					} else if (item.name.toLowerCase().includes(lowerCaseSearchTerm)) {
						return item;
					} else {
						return null;
					}
				}).filter(item => item !== null);
			}

			if (this.active_platform) {
				const pKey = this.active_platform;
				res = res.map(item => {
					if (typeof item.buckets !== 'undefined') {
						const filteredBuckets = item.buckets.filter(b => this.getPlatform(b.name) === pKey);
						return filteredBuckets.length > 0 ? { ...item, buckets: filteredBuckets } : null;
					} else {
						return this.getPlatform(item.name) === pKey ? item : null;
					}
				}).filter(item => item !== null);
			}

			return res;
		},
		groupedByCategory() {
			const groups = [];
			const filteredData = this.filteredTypes;

			for (const category of filteredData) {
				if (typeof category.buckets !== 'undefined' && category.buckets.length > 0) {
					groups.push({
						id: category.id,
						name: category.name,
						type: 'category',
						items: category.buckets.map(bucket => ({
							type: 'bucket',
							bucket,
							categoryId: category.id
						}))
					});
				} else if (typeof category.buckets === 'undefined') {
					let sampleGroup = groups.find(g => g.type === 'sample_codes');
					if (!sampleGroup) {
						sampleGroup = {
							id: 'sample_codes',
							name: 'Sample Codes',
							type: 'sample_codes',
							items: []
						};
						groups.push(sampleGroup);
					}
					sampleGroup.items.push({
						type: 'sample_code',
						item: category
					});
				}
			}

			return groups;
		},
	},
	methods: {
		getPlatform(name) {
			if (!name) return 'other';
			const lower = name.toLowerCase();
			for (const p of PLATFORM_LIST) {
				if (lower.includes(p.key)) return p.key;
			}
			return 'other';
		},
		changePlatformFilter(key) {
			this.active_platform = this.active_platform === key ? '' : key;
			if (this.active_platform) {
				this.active_type = '';
			}
		},
		formatDate(dateString) {
			if (!dateString) return '';
			const date = new Date(dateString);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
		randomString(length) {
			const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			let result = '';
			for (let i = 0; i < length; i++) {
				result += chars.charAt(Math.floor(Math.random() * chars.length));
			}
			return result;
		},
		openDescriptionModal(bucket) {
			this.descriptionModal.bucketName = bucket.name;
			this.descriptionModal.description = bucket.description;
			this.descriptionModal.show = true;
		},
		closeDescriptionModal() {
			this.descriptionModal.show = false;
			this.descriptionModal.bucketName = '';
			this.descriptionModal.description = '';
		},
		openSampleCodeDescriptionModal(sampleCode) {
			this.descriptionModal.bucketName = sampleCode.name;
			this.descriptionModal.description = sampleCode.description;
			this.descriptionModal.show = true;
		},
		showOlderVersions(bucket) {
			this.showBucket = bucket.releases.length > 0 ? { ...bucket } : null;

			if (this.showBucket && this.showBucket.releases.length > 0) {
				this.showBucket.releases[0].showNote = true;
			}
		},
		toggleReleaseNote(i) {
			if (this.showBucket && this.showBucket.releases[i]) {
				this.showBucket.releases[i].showNote = !this.showBucket.releases[i].showNote;
			}
		},
		containsString(mainString, searchString) {
			return mainString.toLowerCase().includes(searchString.toLowerCase());
		},
		copyDownloadLink(url) {
			url += '?' + this.randomString(8) + '=' + this.randomString(8);

			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(url).then(() => {
					this.showNotification('success', 'Download link copied to clipboard!');
				}).catch(() => {
					this.fallbackCopyTextToClipboard(url);
				});
			} else {
				this.fallbackCopyTextToClipboard(url);
			}
		},
		fallbackCopyTextToClipboard(text) {
			const textArea = document.createElement('textarea');
			textArea.value = text;
			textArea.style.position = 'fixed';
			textArea.style.top = '-9999px';
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				document.execCommand('copy');
				this.showNotification('success', 'Download link copied to clipboard!');
			} catch (err) {
				this.showNotification('error', 'Failed to copy link');
			}

			document.body.removeChild(textArea);
		},
		showNotification(type, message) {
			if (jQuery.append_notification) {
				jQuery.append_notification(type, message);
			}
		},
		latestVersion(releases) {
			if (Array.isArray(releases) && releases.length > 0)
				return releases[0]['name'];
			return '';
		},
		changeViewType(type) {
			if (this.active_type == type) {
				this.active_type = '';
			} else {
				this.active_type = type;
			}
			this.active_platform = '';
		},
		async eulaAgree(href) {
			try {
				await this.$confirm({
					title: 'Information',
					message: `<p>With downloading the Barcoder Mobile SDK, you're agreeing to the terms and conditions of our <a target="_blank" href="${this.homeUrl}EULA">EULA</a></p>`,
					button: {
						no: 'Cancel',
						yes: 'Agree & Download'
					},
					callback: confirm => {
						if (confirm) {
							window.location.href = href + '?' + this.randomString(8) + '=' + this.randomString(8);
						}
					}
				});
			} catch (e) {
				// Dialog dismissed
			}
		},
		async fetchRepoListData() {
			this.isLoading = true;

			try {
				const response = await fetch(this.homeUrl + 'repository/ajax/fetch_repo_list_data');
				const result = await response.json();

				if (result.status) {
					this.repo_list = result.repository_list || [];
					this.sample_codes = result.sample_codes || [];
				} else {
					this.showNotification('error', result.message);
				}
			} catch (error) {
				this.showNotification('error', 'Failed to fetch repository list data');
			} finally {
				setTimeout(() => {
					this.isLoading = false;
				}, 300);
			}
		},
	},
	async mounted() {
		const params = new URLSearchParams(window.location.search);
		const filterParam = params.get('filter');
		if (filterParam && filterParam.trim() !== '') {
			this.filterSearchString = filterParam;
		}
		await this.fetchRepoListData();
	}
}
</script>

<style scoped>
.bucketList {
	position: relative;
}

.stagger-move,
.stagger-enter-active,
.stagger-leave-active {
  transition: all 0.3s ease;
}

.stagger-enter-from,
.stagger-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.stagger-leave-active {
  position: absolute;
}

.bucket-description-content {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.bucket-description-content :deep(p) {
  margin: 0 0 12px 0;
}

.bucket-description-content :deep(p:last-child) {
  margin-bottom: 0;
}

.bucket-description-content :deep(ul),
.bucket-description-content :deep(ol) {
  margin: 0 0 12px 0;
  padding-left: 24px;
}

.bucket-description-content :deep(li) {
  margin-bottom: 4px;
}

.bucket-description-content :deep(a) {
  color: #E52E4C;
  text-decoration: none;
}

.bucket-description-content :deep(a:hover) {
  text-decoration: underline;
}

.bucket-description-content :deep(h1),
.bucket-description-content :deep(h2),
.bucket-description-content :deep(h3),
.bucket-description-content :deep(h4) {
  margin: 0 0 12px 0;
  color: #222;
}

.bucket-description-content :deep(code) {
  background: #F5F5F5;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
}

.bucket-description-content :deep(pre) {
  background: #F5F5F5;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  margin: 0 0 12px 0;
}

.bucket-description-content :deep(blockquote) {
  border-left: 3px solid #E52E4C;
  margin: 0 0 12px 0;
  padding-left: 16px;
  color: #666;
}
</style>
